import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError } from 'rxjs';
import { AgencyLocation } from '../model/agency-location';
import { environment } from 'src/environments/environment';
import { EnvService } from 'src/app/env-service/env.service';
import { GroupEdp } from '../model/group-edp';
import { GroupService } from './group.service';
import { COMPANY_DATA_THEME, COMPANY_ID, GlobalConstants } from '../../shared/global-constants';
import { UserSessionService } from './user-session.service';

@Injectable({
  providedIn: 'root'
})
export class PolicyService {

  constructor(private http: HttpClient,
              private envService: EnvService,
              private groupService: GroupService,
              private userSessionService: UserSessionService) { }

  getAgencyLocationsFor(policyNumber: number): Observable<AgencyLocation[]> {
    const url = environment.getApiUrl(environment.agencyLocationsUrl(policyNumber),
                                      this.envService.contractsApiEndpoint,
                                      this.envService.apiSubscriptionId);
    return this.http.get<AgencyLocation[]>(url);
  }

  getPolicyDataFor(policyNumber: number): Observable<any> {
    const url = environment.getApiUrl(environment.policyEdpUrl(policyNumber),
                                      this.envService.contractsApiEndpoint,
                                      this.envService.apiSubscriptionId);
    //the code below makes a 2nd API call to the group service if the first API call fails
    return this.http.get<GroupEdp>(url).pipe(
      catchError(error => this.groupService.getGroupDataFor(policyNumber))
    );
  }

  async checkTheCompanyIdMatchesExpectedCompanyId(companyId: string, carrier: string){
    const theme : string = carrier? carrier: '';
    if(companyId != '' && theme != ''){
      if(theme == COMPANY_DATA_THEME.SFG && (companyId == COMPANY_ID.SI)){
        return COMPANY_ID.SI;
      } else if(theme == COMPANY_DATA_THEME.SFG && (companyId == COMPANY_ID.YI)){
        //check if enabled or not
        
        //feature flag is unavailable when running locally
        if(window.location.href.startsWith("http://localhost")){
          return COMPANY_ID.YI;
        } else {
          let result = await this.userSessionService.checkForSnyEnabled();
          if(result){
            return COMPANY_ID.YI;
          } else {
            return false;
          }
        }
        
      } else if(theme == COMPANY_DATA_THEME.NM && companyId == COMPANY_ID.NM){
        return COMPANY_DATA_THEME.NM;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  private redirectedPolicy = new BehaviorSubject(false);
  public redirectedYiPolicy = this.redirectedPolicy.asObservable();

  isYiPolicyRedirected(message: boolean) {
    this.redirectedPolicy.next(message)
  }

}